export default "/_next/static/images/Process_Step_3-c2407315ea7f62c09bc0acbc5487ac77.jpg";